import * as React from 'react';
export const konbiniLawsonSvg = React.forwardRef(function konbiniLawsonSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0075BB',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18.578 4.105c2.011.232 3.172.662 3.172 1.177 0 .184-.847 2.25-1.176 2.87-.119.223-.09.29.222.513.43.308.45.608.084 1.26-.308.549-.636.655-1.091.355-.266-.175-.306-.178-.306-.019 0 .1.264.405.585.676.684.577 1.264 1.44 1.609 2.394.234.647.247.973.284 7.018l.039 6.34-.346.348c-.666.67-2.24.965-5.153.963-3.404-.002-5.518-.295-6.133-.848l-.368-.33v-5.806c0-5.209.023-5.904.22-6.766.325-1.425.93-2.609 1.773-3.468.687-.7.783-1.076.148-.572-.368.291-.598.226-.836-.238-.442-.862-.442-.936.008-1.204.524-.31.524-.452-.002-1.947-.467-1.33-.511-1.757-.208-2.03.264-.238 1.34-.554 2.32-.682 1.098-.143 3.927-.146 5.155-.004Zm-4.105.556c-.853.084-2.504.433-2.687.568-.168.124-.118.343.455 1.998.448 1.296.703 1.87.841 1.897.119.023.198-.039.198-.155 0-.106.088-.327.194-.49.145-.223.176-.455.122-.927-.04-.346-.086-.764-.104-.93l-.033-.3h2.684c2.62 0 2.683.006 2.64.24a13.8 13.8 0 0 0-.099.965c-.046.62-.018.756.194.95.136.123.247.298.247.386a.16.16 0 0 0 .16.162c.149 0 1.634-3.248 1.631-3.569-.002-.194-.997-.485-2.387-.7-1.024-.157-2.97-.203-4.056-.095Zm-.663 4.856c-.182.297.235.353 2.402.322 1.913-.028 2.257-.06 2.257-.213s-.346-.185-2.29-.21c-1.538-.019-2.315.014-2.369.1Z',
      fill: '#fff',
    }),
  );
});
konbiniLawsonSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var konbiniLawson = {
  category: 'brand',
  colorable: false,
  name: 'konbiniLawson',
  svg: konbiniLawsonSvg,
};
